import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from '@emotion/react';
import { BaseButton } from '../Button/BaseButton.es.js';
import { VisuallyHidden } from '../../display/VisuallyHidden/VisuallyHidden.es.js';

function BrandButton(_a) {
  var { color = "brand", size = "small" } = _a, props = __rest(_a, ["color", "size"]);
  return color === "brand-nav" ? jsx(
    BaseButton,
    { color: "brand-nav", iconBefore: props.iconBefore || "formAdd", size: "medium" },
    jsx(VisuallyHidden, null, props.children || "Create a Zap")
  ) : jsx(BaseButton, Object.assign({ color, size }, props));
}

export { BrandButton };
//# sourceMappingURL=BrandButton.es.js.map
